import { IMailingList } from './mailing-list.interface';

export class MailingListDetailModel implements IMailingList {
  public mld_key: string = undefined;
  public mls_key: string = undefined;
  public cst_key: string = undefined;
  public mld_start_date: Date = undefined;
  public mld_end_date: Date = undefined;
  public mls_name: string = undefined;
  public mls_type_code: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'mld_start_date':
            case 'mld_end_date':
              var k: 'mld_start_date' | 'mld_end_date' = <any>key;
              if (source[k] == null || source[k] == undefined || source[k] == '') {
                this[k] = null;
              } else {
                this[k] = new Date(source[k]);
              }
            break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
